<template>
	<PageCrumbHeaderLayout class="new-goal-header"
		:crumbs="crumbs"
		:disabled="disabled"
		v-on="bubble( `back`, `crumb` )"
	>
		<template #title>
			{{ title }}
		</template>
	</PageCrumbHeaderLayout>
</template>

<script>
import { EventsMixin, PageCrumbHeaderLayout } from "@teaming/common-ui";
export default {
	name: "NewGoalHeader",
	mixins: [ EventsMixin, ],
	emits: [ "back", "crumb", ],
	components: {
		PageCrumbHeaderLayout,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			required: true,
		},
		/** [ { text:String, route:String, isActive:Boolean, }, ... ] */
		crumbs: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped></style>
